"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const sharegoogle = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-sharegoogle` : '') + (description ? ` desc-sharegoogle` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-sharegoogle"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-sharegoogle"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "M18.75 1.5C21.2353 1.5 23.25 3.51472 23.25 6C23.25 8.48528 21.2353 10.5 18.75 10.5C17.1082 10.5 15.6717 9.62076 14.8858 8.30746L9.65796 10.3401C9.7183 10.634 9.75 10.9383 9.75 11.25C9.75 11.7075 9.68172 12.1491 9.55479 12.5651L15.1161 15.3453C15.9347 14.2266 17.2575 13.5 18.75 13.5C21.2353 13.5 23.25 15.5147 23.25 18C23.25 20.4853 21.2353 22.5 18.75 22.5C16.2647 22.5 14.25 20.4853 14.25 18C14.25 17.5428 14.3182 17.1016 14.4449 16.6859L8.8832 13.9057C8.06449 15.0238 6.74205 15.75 5.25 15.75C2.76472 15.75 0.75 13.7353 0.75 11.25C0.75 8.76472 2.76472 6.75 5.25 6.75C6.89221 6.75 8.32897 7.62968 9.11476 8.94352L14.3422 6.91092C14.2818 6.61674 14.25 6.31208 14.25 6C14.25 3.51472 16.2647 1.5 18.75 1.5ZM18.75 15C17.0931 15 15.75 16.3431 15.75 18C15.75 19.6569 17.0931 21 18.75 21C20.4069 21 21.75 19.6569 21.75 18C21.75 16.3431 20.4069 15 18.75 15ZM5.25 8.25C3.59315 8.25 2.25 9.59315 2.25 11.25C2.25 12.9069 3.59315 14.25 5.25 14.25C6.90685 14.25 8.25 12.9069 8.25 11.25C8.25 9.59315 6.90685 8.25 5.25 8.25ZM18.75 3C17.0931 3 15.75 4.34315 15.75 6C15.75 7.65685 17.0931 9 18.75 9C20.4069 9 21.75 7.65685 21.75 6C21.75 4.34315 20.4069 3 18.75 3Z",
    fill: "inherit"
  }));
};
var _default = exports.default = sharegoogle;